import { IComponentOptions } from 'angular';
import { NameStepCtrl } from './name-step.controller';

export const NameStepComponent: IComponentOptions = {
  template: require('./name-step.html'),
  bindings: {
    currentSchool: '<',
    currentSupport: '<',
    currentSupports: '<',
    supportId: '<',
    nextStep: '&',
    prevStep: '&',
  },
  controller: NameStepCtrl,
};

angular.module('nv.SupportsModule').component('nameStep', NameStepComponent);
